
// ** React Imports
import { useEffect, useState } from 'react';
import { Link, useNavigate, useHistory } from 'react-router-dom'

//reactstrap
import { Button } from 'reactstrap'

//confetti
import useWindowSize from 'react-use/lib/useWindowSize'
import Confetti from 'react-confetti'
//img
import SuccessImg from '../../../assets/images/success-payment.png';

//scss
import './index.scss';

const SuccessPage = () => {
    const { width, height } = useWindowSize();
    const navigate = useNavigate();


    //redirection countdown
    const [count, setCount] = useState(8);


    useEffect (()=>{
        const intervalId = setInterval(() => {
            setCount(prevCount => prevCount - 1);
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    },[])
    
    useEffect(() => {
        const timeOut = setTimeout(() => {
            window.location.href= '/pages/account-settings?tab=3';
        }, 8000);
        return () => clearTimeout(timeOut);
    }, [navigate]);

    return (
        <div className="success-page">
            <Confetti
                width={width}
                height={height}
            />

            <div className="container">
                <div className="success-page__inner">
                    <div className='success-page__img'>
                        <img src={SuccessImg} alt="success" />
                    </div>

                    <div className='success-page__title'>
                        <h2 className='title'>Your Payment is Successful</h2>
                        <p className='thank-note'>Thank you for your payment.</p>
                        <p>We will be redirecting to the Dashboard in {count}s.</p>
                        <Button color='success' tag={Link} to='/dashboard' block outline className='succecc-btn mb-75'>
                            Back to Home
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessPage;